import { Fragment, useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./video-ai.css";
import { IoMdSend } from "react-icons/io";
import axios from "axios";
import { UserAuthContext } from "../../Contexts/UserAuthContext";
import PageHeading from "../../Components/PageHeading/PageHeading";
import swal from "sweetalert";
import CreditsButton from "../../utils/CreditsButton";
import reload from "../../Assets/Images/relaoder.png";
import InfoIcon from "@mui/icons-material/Info";
import { IconButton } from "@material-ui/core";
import SampleVideoModal from "../../Components/VideoAi/SampleVideoModal";
import SampleTextVideo from "../../Components/AIVideoSample/TextVideo";

const VideoAiAuto = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [randomQuestion, setRandomQuestion] = useState("");
  const [modalShow, setModalShow] = useState(false);
  const [attributionPage, setAttributionPage] = useState(true);
  const [selectedOption, setSelectedOption] = useState("");
  const [isBwGradient, setIsBwGradient] = useState(false);
  const [isDark, setIsDark] = useState(false);
  const [isRandomGradient, setIsRandomGradient] = useState(false);
  const [isRandomColor, setIsRandomColor] = useState(false);
  const [isWhite, setIsWhite] = useState(false);
  const [videoModal, setVideoModal] = useState(false);
  const [indexValue, setIndexValue] = useState(0);
  const [isGradient, setIsGradient] = useState(false);
  const [isBoth, setIsBoth] = useState(false);
  const [isRewriteProcessing, setIsRewriteProcessing] = useState(false);
  const [videoPosition, setVideoPosition] = useState(0);


  const resetBackgroundStates = () => {
    setIsBwGradient(false);
    setIsDark(false);
    setIsRandomGradient(false);
    setIsRandomColor(false);
    setIsWhite(false);
  };

  const handleOptionChange = (e) => {
    const value = e.target.value;

    setSelectedOption(value);
    resetBackgroundStates();

    switch (value) {
      case "Black to White Gradient":
        setIsBwGradient(true);
        setVideoPosition(11);
        break;

      case "Random Solid Color":
        setIsRandomColor(true);
        setVideoPosition(12);
        break;

      case "Random Color Gradient":
        setIsRandomGradient(true);
        setVideoPosition(10);
        break;

      case "Black":
        setIsDark(true);
        setVideoPosition(9);
        break;

      case "White":
        setIsWhite(true);
        setVideoPosition(13);
        break;

      default:
        setVideoPosition(0);
        break;
    }
  };

  // Function to get a random question
  const getRandomQuestion = () => {
    const questions = [
      "The Basics of Quantum Physics Explained",
      "Understanding the Human Digestive System",
      "How the Internet Works: A Simple Guide",
      "Introduction to Machine Learning",
      "The History of Ancient Rome",
      "The Science Behind Climate Change",
      "Introduction to the Solar System",
      "How to Write an Effective Essay",
      "Understanding the Stock Market",
      "The Fundamentals of Algebra",
      "The Water Cycle Explained",
      "A Beginner’s Guide to Coding",
      "The French Revolution: A Brief Overview",
      "How Photosynthesis Works",
      "Introduction to World Religions",
      "The Life Cycle of a Star",
      "Understanding Artificial Intelligence",
      "How Does DNA Work?",
      "Introduction to Financial Literacy",
      "The History of the Internet",
      "How the Immune System Protects You",
      "The Basics of Electricity",
      "Exploring the Human Brain",
      "What is Cryptocurrency?",
      "Understanding Probability and Statistics",
      "How to Learn a New Language Fast",
      "The Structure of the Earth",
      "What is the Theory of Evolution?",
      "Introduction to Cybersecurity",
      "How Planes Fly: The Physics of Aviation",
      "The Causes of World War I",
      "Understanding Chemical Reactions",
      "How to Create a Budget That Works",
      "The Basics of Astronomy",
      "Introduction to Political Science",
      "How Do Vaccines Work?",
      "Understanding Renewable Energy",
      "The Anatomy of the Human Heart",
      "The History of Mathematics",
      "Introduction to Blockchain Technology",
      "The Life of Plants: An Overview",
      "How to Improve Your Memory",
      "Understanding the Laws of Motion",
      "The Basics of Digital Marketing",
      "Introduction to Public Speaking",
      "How to Study Effectively",
      "Understanding Ocean Currents",
      "The History of Ancient Egypt",
      "Introduction to Psychology",
      "The Basics of Graphic Design",
      "How to Build Good Habits",
      "Understanding Global Warming",
      "The Fundamentals of Trigonometry",
      "The Science of Happiness",
      "Introduction to Data Science",
      "How to Develop Critical Thinking Skills",
      "Understanding the Human Skeletal System",
      "The History of the Renaissance",
      "Introduction to Organic Chemistry",
      "The Basics of Video Editing",
      "How the Nervous System Works",
      "Understanding the Fundamentals of Music Theory",
      "The History of the Industrial Revolution",
      "Introduction to Environmental Science",
      "How to Conduct Effective Research",
      "Understanding the Periodic Table",
      "The Basics of 3D Printing",
      "Introduction to Ethical Hacking",
      "How to Write a Research Paper",
      "Understanding the Human Respiratory System",
      "The History of World War II",
      "Introduction to Sociology",
      "The Basics of Sound Waves",
      "How to Improve Your Public Speaking Skills",
      "Understanding Genetic Engineering",
      "The Fundamentals of Calculus",
      "The Science of Sleep",
      "Introduction to Space Exploration",
      "How to Prepare for Exams Effectively",
      "Understanding Light and Optics",
      "The History of the Cold War",
      "Introduction to Microbiology",
      "How to Create a Business Plan",
      "Understanding Earthquakes",
      "The Basics of Project Management",
      "Introduction to Machine Learning Algorithms",
      "How to Set and Achieve Goals",
      "Understanding Ecosystems",
      "The History of the American Civil War",
      "Introduction to Robotics",
      "The Basics of Human Anatomy",
      "How to Build a Website from Scratch",
      "Understanding the Solar System",
      "The Science Behind Vaccines",
      "Introduction to Web Development",
      "How to Excel in Math",
      "Understanding Nutrition and Diet",
      "The History of Computers",
      "Introduction to International Relations",
      "The Basics of Electrical Circuits",
      "How to Develop Time Management Skills",
      "Understanding Black Holes",
      "The History of Ancient Greece",
      "Introduction to Statistics",
      "How to Improve Your Writing Skills",
      "Understanding the Water Cycle",
      "The Fundamentals of Economics",
      "The Science of Climate Change",
      "Introduction to Virtual Reality",
      "How to Be More Productive",
      "Understanding the Immune Response",
      "The History of the Space Race",
      "Introduction to Biology",
      "The Basics of Investing",
      "How to Develop Problem-Solving Skills",
      "Understanding Human Evolution",
      "The History of Art Movements",
      "Introduction to Artificial Neural Networks",
      "The Science of Exercise and Fitness",
      "How to Create Effective Presentations",
      "Understanding Cellular Respiration",
      "The History of the French Revolution",
      "Introduction to Genetic Engineering",
      "The Basics of Human Geography",
      "How to Plan a Career Path",
      "Understanding the Laws of Thermodynamics",
      "The History of Ancient China",
      "Introduction to Entrepreneurship",
      "The Science of Sound",
      "How to Stay Focused While Studying",
      "Understanding Marine Biology",
      "The Basics of Marketing Strategies",
      "Introduction to Philosophy",
      "How to Develop Leadership Skills",
      "Understanding Human Rights",
      "The History of the Roman Empire",
      "Introduction to Social Media Marketing",
      "The Science of Light",
      "How to Overcome Procrastination",
      "Understanding the Earth's Atmosphere",
      "The History of the Scientific Revolution",
      "Introduction to Nanotechnology",
      "The Basics of Creative Writing",
      "How to Communicate Effectively",
      "Understanding Ecosystem Dynamics",
      "The History of Ancient India",
      "Introduction to Game Design",
      "The Science of Nutrition",
      "How to Develop Emotional Intelligence",
      "Understanding the Structure of Atoms",
      "The History of Space Exploration",
      "Introduction to Web Security",
      "The Basics of Financial Planning",
      "How to Learn Faster",
      "Understanding Quantum Mechanics",
      "The History of the Middle Ages",
      "Introduction to Astrobiology",
      "The Science of Motivation",
      "How to Build a Personal Brand",
      "Understanding the Greenhouse Effect",
      "The History of the Atomic Bomb",
      "Introduction to Cryptography",
      "The Basics of User Experience Design",
      "How to Think Critically",
      "Understanding Social Psychology",
      "The History of the Byzantine Empire",
      "Introduction to Geology",
      "The Science of Stress Management",
      "How to Build a Mobile App",
      "Understanding the Structure of DNA",
      "The History of the Silk Road",
      "Introduction to Behavioral Economics",
      "The Basics of Cloud Computing",
      "How to Overcome Test Anxiety",
      "Understanding Plate Tectonics",
      "The History of Medieval Europe",
      "Introduction to Renewable Energy Technologies",
      "The Science of Cognitive Biases",
      "How to Develop a Growth Mindset",
      "Understanding the Human Circulatory System",
      "The History of the Renaissance Art",
      "Introduction to Artificial Intelligence Ethics",
      "The Basics of Computer Networks",
      "How to Improve Your Logical Reasoning Skills",
      "Understanding the Physics of Gravity",
      "The History of Modern Medicine",
      "Introduction to Environmental Sustainability",
      "The Science of Human Behavior",
      "How to Build Confidence",
      "Understanding the Process of Evolution",
      "The History of Space Technology",
      "Introduction to Astrophysics",
      "The Basics of Data Analysis",
      "How to Cultivate Creativity",
      "Understanding Chemical Bonding",
      "The History of the Industrial Age",
      "Introduction to Digital Art",
      "The Science of Learning",
      "How to Create a Successful YouTube Channel",
      "Understanding the Anatomy of Plants",
    ];

    const randomIndex = Math.floor(Math.random() * questions.length);
    return questions[randomIndex];
  };

  // Set random question when component mounts
  useEffect(() => {
    setRandomQuestion(getRandomQuestion());
  }, []);

  const [isGenerateButtonDisabled, setIsGenerateButtonDisabled] =
    useState(false);

  const { AIuser, userRefetch, setUserRefetch, isBack } =
    useContext(UserAuthContext);

  const [inputText, setInputText] = useState("");
  const [enableOwnScript, setEnableOwnScript] = useState(false);
  const [generatedText, setGeneratedText] = useState(
    "Artificial Intelligence (AI) is a rapidly growing field of technology that is revolutionizing the way we interact with the world. AI is the ability of a computer or machine to think and learn like a human. It is a form of intelligence that is based on algorithms and data, rather than on human intelligence.\n\n\nAI is used in a variety of applications, from self-driving cars to medical diagnosis. AI is used to automate tasks that would otherwise require human intelligence. For example, AI can be used to analyze large amounts of data and make decisions based on the data. AI can also be used to recognize patterns in data and make predictions about future events.\n\n\nAI can also be used to create virtual assistants that can respond to user queries and provide helpful information. AI is also being used to create robots that can interact with humans in a more natural way. These robots can be used to perform tasks such as cleaning, cooking, and providing companionship.\n\n\nAI is also being used to create virtual reality experiences that can be used for entertainment or educational purposes. AI is also being used to create autonomous vehicles that can drive themselves. These vehicles are being developed to reduce the number of accidents on the road and to make transportation more efficient.\n\n\nAI is also being used to create autonomous drones that can be used for surveillance or delivery purposes. AI is also being used to create intelligent machines that can understand natural language and respond to user queries. These machines can be used to provide customer service or to provide information about products and services.\n\n\nAI is also being used to create intelligent robots that can interact with humans in a more natural way. AI is a rapidly growing field of technology that is revolutionizing the way we interact with the world. AI is being used in a variety of applications, from self-driving cars to medical diagnosis. AI is also being used to create autonomous vehicles, robots, and intelligent machines that can understand natural language and respond to user queries. AI is a powerful tool that is being used to create a more efficient and safer world."
  );

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    if (location?.state?.back && isBack) {
      const backText = location?.state?.text;
      const backInput = location?.state?.inputText;
      setInputText(backInput);
      setGeneratedText(backText);
    }
    // const isBack = location?.state?.back;
  }, [location, isBack]);

  useEffect(() => {
    if (location.state !== null) {
      setInputText(location.state.requestQues);
      setGeneratedText(location.state.response);
    }
  }, [location.state]);

  function generateRandomAlphanumeric() {
    const chars =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let result = "";
    for (let i = 0; i < 8; i++) {
      const randomIndex = Math.floor(Math.random() * chars.length);
      result += chars[randomIndex];
    }
    return result;
  }

  const handleSubmitCredits = async (e) => {
    const deductedCredits = AIuser.credits - 35;

    // console.log("question", question, conversation);
    await axios
      .put(
        "https://backend.whalesai.com/api/dashboard/user_signup-signin/update-credits",
        { email: AIuser?.email, credits: deductedCredits },
        {
          headers: {
            authorization: `Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9`,
          },
        }
      )
      .then((res) => {
        if (res.status === 200) {
          setUserRefetch(!userRefetch);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const ConfirmVideo = async () => {
    if (isGenerateButtonDisabled) return;

    if (AIuser.credits > 35) {
      setTimeout(() => {
        const wrapper = document.createElement("div");
        wrapper.innerHTML = `<p></p> <p class="text-white">we are generating the video for you. We will send the video links to <span class="text-warning">${AIuser?.email}</span>. It might take up to 10 mins. <br/> You can generate more contents while waiting for our email.</p> `;

        swal({
          content: wrapper,
          icon: "success",
          button: "Close",
          className: "modal_class_success",
        }).then(() => {
          // Update the button text to "Refreshing the page for you"
          swal({
            icon: "success",
            button: {
              text: "Refreshing the page for you",
              className: "bg-danger",
            },
            className: "modal_class_success",
            closeOnClickOutside: false, // Prevent closing by clicking outside
          });

          // Reload the page after a short delay to allow the user to see the updated text
          setTimeout(() => {
            window.location.reload();
          }, 1000); // Adjust the delay as needed
        });
      }, 1000);

      setGeneratedText("");
      setIsLoading(true);
      handleSubmitCredits();
      let bodyContent;
      if (isBoth) {
        bodyContent = {
          email: AIuser?.email,
          userId: AIuser?._id,
          isDark,
          isBwGradient,
          isRandomColor,
          isRandomGradient,
          isWhite,
          transactionId: generateRandomAlphanumeric(),
          attributionPage,
          credit: 35,
        };
      } else {
        bodyContent = {
          email: AIuser?.email,
          userId: AIuser?._id,
          isDark,
          isBwGradient,
          isRandomColor,
          isRandomGradient,
          isWhite,
          transactionId: generateRandomAlphanumeric(),
          attributionPage,
          credit: 35,
        };
      }
      // const bodyContent = {
      //   email: AIuser?.email,
      //   userId: AIuser?._id,
      //   isDark: isDark,
      //   isGradient: isGradient,
      //   isRandomColor: isRandomColor,
      //   transactionId: generateRandomAlphanumeric(),
      // };

      if (enableOwnScript) {
        bodyContent.description = inputText;
      } else {
        bodyContent.question = inputText;
      }

      try {
        const response = await fetch(
          `https://backend.whalesai.com/api/v1/video-ai-test/create`,
          // https://backend.whalesai.com/api/v1/img/generate-video?dimension=all
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(bodyContent),
          }
        );

        if (!response.ok) {
          throw new Error("Failed to generate video");
        }

        const data = await response.json();
        if (data.message === "Video created successfully") {
          alert("video created successfully");

          setIsLoading(false);
        } else {
          throw new Error("Failed to generate video");
        }
      } catch (error) {
        console.error("Error generating video:", error);
      }
    } else {
      swal({
        text: "You don't have enough credits! Please buy credits to continue.",

        icon: "error",
        buttons: "Ok",
        className: "modal_class_success",
      }).then((value) => {
        if (value) {
          navigate("/purchase");
        }
      });
    }
  };

  const DisableBtn = async () => {
    const wrapper = document.createElement("div");
    wrapper.innerHTML = `<p></p> <p class="text-danger">Warning: Your text exceeds 600 words. Please edit it to 600 words or let the AI generate a shortened version for you.................................</p> `;

    return swal({
      content: wrapper,
      icon: "error",
      buttons: "Ok",
      className: "modal_class_success",
    });
  };

  const handleTextChange = (e) => {
    const text = e.target.value;
    const wordCount = text.split(/\s+/).length;
    setInputText(text);
    setGeneratedText("");

    if (enableOwnScript && wordCount > 600) {
      setIsGenerateButtonDisabled(true);
    } else {
      setIsGenerateButtonDisabled(false);
    }
  };

  console.log(inputText.length);

  const handleTrigger = () => {
    setInputText("");
    setEnableOwnScript(false);
  };

  const reWritEScript = async () => {
    setIsRewriteProcessing(true);

    console.log("Text Sending:::::::::::::::::", inputText);
    try {
      const response = await fetch(
        "https://backend.whalesai.com/api/v1/video-ai-test/re-write",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ description: inputText }),
        }
      );

      if (!response.ok) {
        throw new Error(`Error: ${response.statusText}`);
      }

      const data = await response.json();
      console.log("Response:", data?.data);
      setInputText(data?.data);
      setIsRewriteProcessing(false);
    } catch (error) {
      console.error("Error:", error);
      // alert("Request failed. Please try again.");
    }
  };

  const color = { isDark, isGradient, isRandomColor, isBoth };

  console.log("video color ==>>>", color);

  return (
    <Fragment>
      <PageHeading
        title={"Text Video AI"}
        description={
          "The Text Video AI can swiftly produce text-based videos with voiceovers."
        }
      />
      <div className="img-ai-container container pb-5">
        <div
          sx={{
            maxWidth: "872px",
            paddingInline: "12px",
            marginInline: "auto",
          }}
        >
          {/* <div className="d-flex justify-content-center align-items-center">
            <IconButton
              style={{ color: "#ffa21f" }}
              onClick={() => setVideoModal(true)}
              title="See sample video"
            >
              <InfoIcon />
            </IconButton>
          </div>

          <SampleTextVideo
                setVideoModal={setVideoModal}
                videoModal={videoModal}
                indexValue={indexValue}
          /> */}
          <div className="position-relative">
            {" "}
            {/* Adjust height as needed */}
            <IconButton
              style={{
                color: "#ffa21f",
                position: "absolute",
                top: "calc(0px - 100px)", "@media (max-width: 575px)": { top: "calc(0px - 70px)" }, // Moves 30px up from the top
                left: "50%", // Horizontal center
                transform: "translateX(-50%)", // Ensures it's centered from its width
              }}
              onClick={() => setVideoModal(true)}
              title="See sample video"
            >
              <InfoIcon />
            </IconButton>
          </div>

          {/* <SampleTextVideo
            setVideoModal={setVideoModal}
            videoModal={videoModal}
            indexValue={indexValue}
          /> */}

          <SampleTextVideo
            setVideoModal={setVideoModal}
            videoModal={videoModal}
            indexValue={indexValue}
          />

          <div className="d-flex align-items-center justify-content-center centralize-credits-btn-sm">
            <div className="d-flex ">
              <CreditsButton />
            </div>
          </div>
          <p style={{ fontSize: '8px' }} className="text-white text-center mt-2 mb-0 centralize-credits-btn-sm">
            35 Credits per video
          </p>
        </div>

        <div className="container pt-3">
          <div style={{ maxWidth: "850px" }} className="mx-auto">
            <div className="d-flex align-items-center justify-content-center">
              <p className="text-white centralize-credits-btn-sm text-center">
                {`${enableOwnScript ? "Enter your own script (max 600 words)." : "Provide a detailed description of the video you would like to create."

                  }`}
              </p>
            </div>
            {/* "Provide a detailed description of the video you would like to create." */}

            {!enableOwnScript && (
              <div
                style={{ flexDirection: "column" }}
                className="d-flex align-items-center text-center text-sm-start"
              >

                <p
                  onClick={() => setInputText(randomQuestion)}
                  style={{ cursor: "pointer" }}
                  className="text-warning my-2 text-center"
                >
                  <span className="text-danger">Example:</span> {randomQuestion}
                </p>
                <img
                  onClick={() => setRandomQuestion(getRandomQuestion())}
                  style={{ cursor: "pointer" }}
                  src={reload}
                  alt="reload"
                  width="30"
                  height="30"
                  className="my-2"
                />
              </div>
            )}
            <div
              className="ai-send-text mt-2 position-relative"
              style={{ marginBottom: 10, paddingBottom: "23px" }}
            >
              <span
                className="text-danger"
                style={{
                  position: "absolute",
                  top: "10px",
                  right: "15px",
                  zIndex: 10
                }}
              >
                *
              </span>
              <form>
                <div className="d-flex justify-content-between align-items-end">
                  <textarea
                    className={`bg-transparent border-0 w-100 text-white ask-ai-fonts ai-textarea ${!enableOwnScript && ""}`}
                    type="text"
                    lang="en"
                    placeholder=""
                    value={inputText}
                    id="inputText"
                    name="inputBox"
                    rows={enableOwnScript ? 8 : 4}
                    onChange={handleTextChange}
                  />
                  <div
                    className="ai-sent-item d-flex justify-content-end align-items-end"
                    type="submit"
                    style={{ cursor: "pointer" }}
                  >
                    {/* <IoMdSend className="ask-ai-sent" onClick={ConfirmVideo} /> */}
                  </div>
                </div>
              </form>
              {inputText && enableOwnScript && (
                <p
                  className={`mb-0 text-white me-auto ${inputText?.split(/\s+/).length == 600 && "text-danger"}`}
                  style={{
                    fontSize: "13px",
                    fontWeight: "500",
                    letterSpacing: "0.1px",
                    position: "absolute",
                    right: "17px",
                    bottom: "9px",
                  }}
                >
                  {inputText?.split(/\s+/).length}/600 words
                </p>
              )}
            </div>
            {/* {!enableOwnScript && (
              <div
                style={{ flexDirection: "column" }}
                className="d-flex align-items-center text-center text-sm-start"
              >
                <p
                  onClick={() => setInputText(randomQuestion)}
                  style={{ cursor: "pointer" }}
                  className="text-warning my-2 text-center"
                >
                  <span className="text-danger">Example:</span> {randomQuestion}
                </p>
                <img
                  onClick={() => setRandomQuestion(getRandomQuestion())}
                  style={{ cursor: "pointer" }}
                  src={reload}
                  alt="reload"
                  width="30"
                  height="30"
                  className="my-2"
                />
              </div>
            )} */}
            {inputText?.split(/\s+/).length > 600 && (
              <div
                style={{ cursor: "pointer" }}
                onClick={() => handleTrigger()}
                className="warning text-center"
              >
                Warning: Your text exceeds 600 words. Please edit it to 600
                words or let the AI generate a shortened version for you.
              </div>
            )}

            {enableOwnScript && inputText?.length > 0 && (
              <div className="d-flex align-items-center justify-content-center">
                <button
                  onClick={reWritEScript}
                  style={{
                    // background: "#007DEB",
                    color: "black",
                    textAlign: "center",
                    marginTop: "10px",
                    // width: "360px",
                    // fontWeight :''
                  }}
                  className="btn mx-auto btn-warning text-uppercase px-2"
                >
                  {!isRewriteProcessing
                    ? "USE AI to rewrite according to requirements"
                    : "Processing. . ."}
                </button>
              </div>
            )}
            {/* 4 step here  */}
            {/* <div className="d-flex fs-5 align-items-center justify-content-center">
              <input
                type="checkbox"
                className=""
                checked={isGradient}
                onChange={handleCheckGradient}
              />
              <p
                className="ms-2 mt-3 text-white text-uppercase"
                style={{ fontSize: "14px" }}
              >
                Gradient
              </p>
              
            </div> */}

            {/* <div className="d-flex fs-5 align-items-center justify-content-center">
              <input
                type="checkbox"
                className=""
                checked={isRandomColor}
                onChange={handleCheckRandomColor}
              />
              <p
                className="ms-2 mt-3 text-white text-uppercase"
                style={{ fontSize: "14px" }}
              >
                Random Colors
              </p>
              
            </div> */}

            {/* <div className="d-flex fs-5 align-items-center justify-content-center">
              <input
                type="checkbox"
                className=""
                checked={isBoth}
                onChange={handleCheckBothGR}
              />
              <p
                className="ms-2 mt-3 text-white text-uppercase"
                style={{ fontSize: "14px" }}
              >
                Random Color Gradients
              </p>
              
            </div> */}

            {/* <div className="d-flex fs-5 align-items-center justify-content-center">

              <SampleVideoModal
                setModalShow={setModalShow}
                modalShow={modalShow}
              />
              <input
                type="checkbox"
                className=""
                checked={isDark}
                onChange={handleCheckboxChange}
              />
              <p
                className="ms-2 mt-3 text-white text-uppercase"
                style={{ fontSize: "14px" }}
              >
                Classic Black and White
              </p>
              
            </div> */}

            {/* <IconButton
                style={{ color: "#ffa21f" }}
                onClick={() => setModalShow(true)}
                title="See sample video"
                className=""
              >
                <InfoIcon />
              </IconButton> */}

            {/* close 4 step */}

            <div
              className="d-flex align-items-center justify-content-center text-center mt-4"
            >
              <input
                type="checkbox"
                id="attributionCheckboxInline"
                style={{ marginRight: '8px' }}
                checked={attributionPage}
                onChange={(e) => setAttributionPage(e.target.checked)}
              />
              <label htmlFor="attributionCheckboxInline" className="text-white" style={{ fontSize: '14px', cursor: 'pointer' }}>
                The Attribution
              </label>
            </div>

            <div
              className="d-flex align-items-center justify-content-center text-center mt-4 gap-2"
              style={{ cursor: "pointer" }}
            >
              <select
                className="form-select form-select-sm text-uppercase"
                value={selectedOption}
                onChange={handleOptionChange}
                style={{ width: "220px" }}
              >
                <option value="">Please select Background</option>

                <option value="Black to White Gradient">
                  Black to White Gradient
                </option>

                <option value="Random Solid Color">
                  Random Solid Color
                </option>

                <option value="Random Color Gradient">
                  Random Color Gradient
                </option>

                <option value="Black">
                  Black
                </option>

                <option value="White">
                  White
                </option>
              </select>
              <span className="text-danger">*</span>
              {videoPosition == 0 ? (
                " "
              ) : (
                <IconButton
                  style={{ color: "#ffa21f" }}
                  onClick={(e) => {
                    e.stopPropagation(); // Prevent the SweetAlert from triggering
                    setModalShow(true);
                  }}
                  title="See sample video"
                  className="mt-0"
                >
                  <InfoIcon />
                </IconButton>
              )}
            </div>



            <div className="mt-4 text-center">
              <button
                onClick={() => {
                  setInputText("");
                  setGeneratedText("");
                  setIsGenerateButtonDisabled(false);
                }}
                className="clear-button rounded"
              >
                Clear
              </button>

              <button
                onClick={ConfirmVideo}
                className={`generate-button rounded ${!inputText || !selectedOption ? "bg-secondary" : ""}`}
                disabled={!inputText || !selectedOption || isLoading}
              >
                Generate
              </button>
            </div>
            <p className="mt-3"></p>
            <div style={{ fontSize: '8px !important' }} className="animate text-md-center mt-4 text-lg-center text-center d-flex justify-content-center mb-4 force-small-font">
              Please do not navigate away from the browser.
              <br /> Doing so will stop the process.
            </div>
            <div className="text-md-center text-white text-lg-center text-center d-flex justify-content-center force-small-font mt-1">
              While AI strives for accuracy, it may occasionally make mistakes. <br />Please verify any important information.
            </div>
            <p className="mt-3"></p>
            {/* <div className="d-flex align-items-center justify-content-center">
              {!enableOwnScript ? (
                <button
                  onClick={() => setEnableOwnScript(true)}
                  style={{ fontSize: "14px" }}
                  className="m-auto btn btn-info"
                >
                  Please click here to enter your own script.
                </button>
              ) : (
                <button
                  onClick={() => setEnableOwnScript(false)}
                  style={{ fontSize: "14px" }}
                  className="m-auto btn btn-info"
                >
                  Please click here to let AI generate for you.
                </button>
              )}
            </div> */}
            {/* <p className="text-warning text-center mt-3 fontsizeforprowerd">
              <small>Powered by OpenAi</small>
            </p> */}

            <div className="btnvideoDiv"></div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default VideoAiAuto;
